import React, { useState, useRef, isValidElement } from 'react';
import styled from '@emotion/styled';
import {
  white,
  richBlack,
  vLtPurple,
  dkPurple,
  dkViolet,
  blurple
} from '@sentry/static-shared/utils/css/colors';
import { defaultDrop } from '@sentry/static-shared/utils/css/shadows';
import CustomMDXRenderer from '../CustomMDXRenderer';
import Caret from '@sentry/static-www/src/components/atoms/Caret';
import RichTextRenderer from '../organisms/RichTextRenderer';

const BasicAccordionCard = ({data, mode, multiColumn = false}) => {
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');
  const [setRotate, setRotateState] = useState('accordion__icon');

  const content = useRef(null);

  function toggleAccordion() {
    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(
      setActive === 'active' ? '0px' : `${content.current.scrollHeight}px`
    );
    setRotateState(
      setActive === 'active' ? 'accordion__icon' : 'accordion__icon rotate'
    );
  }

  const renderAnswerComponent = (answer) => {
    if (answer && answer.body) {
      return (
        <CustomMDXRenderer body={answer.body} />
      )
    } else if (answer && answer.childMarkdownRemark) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: answer.childMarkdownRemark.html,
          }}
        />
      )
    } else if (isValidElement(answer) || typeof answer === 'string') {
      return answer;
    } else if (answer.raw) {
      return <RichTextRenderer {...{ richTextDocument: answer }} />;
    } else {
      return (
        <div>
          <p>No answer provided.</p>
        </div>
      )
    }
  }

  return (
    <AccordionItem>
      <AccordionButton
        className={`accordion ${setActive} ${mode}`}
        onClick={toggleAccordion}
      >
        <AccordionTitle className={mode}>{data.title}</AccordionTitle>
        <AccordionIcon className={`${setRotate} ${mode}`}></AccordionIcon>
      </AccordionButton>
      <AccordionContent ref={content} style={{ maxHeight: `${setHeight}` }} multiColumn={multiColumn}>
        <AccordionText>
          {renderAnswerComponent(data.answer)}
        </AccordionText>
      </AccordionContent>
    </AccordionItem>
  );
};

const AccordionItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
`;
const AccordionButton = styled.button`
  background-color: ${white};
  border: none;
  cursor: pointer;
  padding: 1rem;
  line-height: 1.5;
  display: flex;
  align-items: center;
  border-radius: 3px;
  outline: none;
  transition: background-color 0.25s ease;
  box-shadow: ${defaultDrop};
  &:hover {
    background-color: ${vLtPurple};
  }
  &.light {
    background-color: ${richBlack};
    color: white;
    &:hover {
      background-color: ${blurple};
    }
  }
`;
const AccordionIcon = styled(Caret)`
  margin-left: auto;
  transition: transform 0.5s ease;
  height: 1rem;
  width: 1rem;
  flex-shrink: 0;
  transform-origin: center center;
  &.rotate {
    transform: rotate(90deg);
  }
  &.light {
    fill: white;
  }
`;
const AccordionTitle = styled.p`
  margin: 0;
  color: ${richBlack};
  letter-spacing: 0.5px;
  flex: 1;
  text-align: left;
  font-size: 1.25rem;
  line-height: 1.25;
  font-weight: bold;
  &.light {
    color: white;
  }
`;
const AccordionContent = styled.div`
  overflow: hidden;
  transition: max-height 0.5s ease;
  color: ${props => props.multiColumn ? 'white': 'inherit'}
`;
const AccordionText = styled.div`
  font-size: 1em;
  padding: 0.5rem 2rem 0 1rem;
  p {
  }
`;

export default BasicAccordionCard;
